<template>
    <v-flex>
        <books-list></books-list>
    </v-flex>
</template>

<script>
    import BooksList from "../components/BooksList";

    export default {
        components: {
            BooksList
        }
    }
</script>

<style scoped>

</style>
